import { formatMoney } from '../../helpers/formatters';
import { Transaction, Session } from '../../types/checkout';

import { common } from '../upstream';
import { OperationItem, CaptureState, NewOperationItem } from '../types';

export const getTransactionItems = (transaction: Transaction, session: Session) => {
    return common.getTransactionItems(transaction, session);
};

export const getOperationItemsForCapture = (transaction: Transaction, session: Session) => {
    return getTransactionItems(transaction, session).map(item => ({
        persisted: item,
        operation: {
            amount: item.capturableAmount,
            quantity: item.capturableQuantity,
        },
    }));
};

export const getOperationItemsForRefund = (transaction: Transaction, session: Session) => {
    return getTransactionItems(transaction, session).map(item => ({
        persisted: item,
        operation: {
            amount: 0,
            quantity: 0,
        },
    }));
};

export const getChangedItems = (items: NewOperationItem[]) => {
    return items.filter(item => item.operation.amount > 0 || item.operation.quantity > 0);
};

export const getAmount = (changedItems: OperationItem[]) => {
    return changedItems.reduce((sum: number, item: OperationItem) => item.operation.amount + sum, 0);
};

export const formatAmountString = (lng: string, transaction: Transaction, value: string): string => {
    const sanitized = value.replace(',', '.').replace(/\s/g, '');
    const amount = parseFloat(sanitized);
    if (isNaN(amount)) {
        return value;
    }
    return formatMoney(lng, amount, transaction.currency);
};

export const checkAllItemsSelected = (items: OperationItem[]) =>
    items.reduce((accumulator, item) => {
        if (item.persisted.captureState === CaptureState.Authorized) {
            return accumulator;
        }
        return (
            accumulator &&
            item.operation.amount === item.persisted.refundableAmount &&
            item.operation.quantity === item.persisted.refundableQuantity
        );
    }, true);
